/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { FunctionComponent } from "react";
import "./PaginationEllipsis.scss";

export const PaginationEllipsis: FunctionComponent = () => {
  return <div className="pagination-ellipsis">
    ...
  </div>;
};

